export let COLLECTION_ID = /*#__PURE__*/function (COLLECTION_ID) {
  COLLECTION_ID["CAMPAIGNS"] = "CampaignManager/campaigns";
  COLLECTION_ID["USER_CONFIG"] = "CampaignManager/userConfig";
  return COLLECTION_ID;
}({});
//# sourceMappingURL=dataCollectionId.js.map